module.exports = __webpack_public_path__ + "media/images/social-media/linkedin-c0d6843573e4432f915fe7cc282054dc.png";